import { isEmpty } from "utils/common-utils";
import { RequiredTextProps } from "../components/FormFactory/form-factory-types";

export const resetFormFieldValues = (formFields: any, fieldNames: string[], form: any) => {
  if (!isEmpty(fieldNames)) {
    fieldNames.forEach((fieldName: string) => {
      if (formFields.hasOwnProperty(fieldName)) {
        formFields[fieldName].value = "";
      }
    });
    form.resetFields([...fieldNames]);
  }
};

export const updatedFormData = (
  formFields: object,
  value: string | number | boolean,
  key: string,
) => {
  const errors: any = {};
  const updateFormFields: any = { ...formFields };
  updateFormFields[key].value = value;
  errors[key] = "";

  return {
    updateFormFields,
    errors,
  };
};

export const getSubmissionData = (formFields: any) => {
  const fieldData: any = {};
  const required: any = {};

  for (const key in formFields) {
    const { elementConfigs } = formFields[key];
    const { validField = true } = elementConfigs;

    if (validField) {
      const fieldValue = formFields[key].value ? formFields[key].value : "";

      if (fieldValue) {
        fieldData[key] = fieldValue;
      } else {
        required[key] = requiredText(formFields[key]);
      }
    }
  }
  return {
    fieldData,
    required,
  };
};

const requiredText = (field: RequiredTextProps) => {
  const { elementConfigs } = field;
  const { requiredTxt } = elementConfigs;

  return requiredTxt || "Required";
};
